<template>
  <div class="ad-products-container">
    <div class="ad-products-title">
      <span class="title">产品专区</span>
      <a href="/academy/product_list/" class="more" target="_blank"
        @mouseenter="hoverImg = true"
        @mouseleave="hoverImg = false">
        更多
        <img src="../../../static/images/icon/login-icon/help_more_hover.svg"
          v-if="hoverImg">
        <img src="../../../static/images/icon/login-icon/help_more.svg"
          v-else>
      </a>
    </div>
    <div class="ad-products">
      <transition-group name="opacity-switch">
        <div class="ad-product" v-for="product in products" @mouseenter="product.isHover = true" @mouseleave="product.isHover = false" :key="product.title">
          <img class="img-style" :src="getSrc(product.img)">
          <div class="product-title">{{product.title}}</div>
          <transition-group name="opacity" tag="div" class="btn-list" v-if="product.link && product.product_link">
            <div class="product-button-list" v-if="product.isHover" :key="product.desc">
              <div class="product-btn-course" @click="go2ProductLesson(product)" :key="product.product_link">产品教程</div>
              <div class="product-btn-use" @click="go2Product(product)"  :key="product.link">立即使用</div>
            </div>
          </transition-group>
          <transition-group name="opacity-desc" tag="div">
            <div class="product-content" :title="product.desc"
              v-if="!product.isHover || !product.link" :key="product.desc">{{product.desc}}</div>
          </transition-group>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './ad-products.scss'
</style>

<script>
  // export { default } from './ad-lessons.js'
  import {
    subDomainChange
  } from 'Src/util/tool'

  export default {
    data () {
      return {
        products: [],
        hoverImg: false,
      }
    },
    computed: {
      hoverArrs () {
        return this.hovers
      },
      // cdn图片的src
      getSrc(){
        return val => GET_IMG_BYTE_SRC(val)
      }
    },
    props: {
      // products: {
      //   type: Array,
      //   default () {
      //     return [1,2,3,4]
      //   }
      // }
    },
    mounted () {
      this.products = [{
        title: '智能建站',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/9fa3aae1f405443ef3025efdef17eb20.svg~tplv-yvqzo4lhg5-image.image',
        desc: '免费落地页制作工具，只需通过模板或简单拖拽即可快速制作推广页面',
        link: '//' + H5OE_ORIGIN + '/marketing/home',
        product_link: '/academy/product_detail/?id=40&one=%E6%95%88%E6%9E%9C%E5%B9%BF%E5%91%8A&oneId=1&two=%E5%BB%BA%E7%AB%99%E5%B7%A5%E5%85%B7&twoId=39'
      }, {
        title: '飞鱼CRM',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/0e4d20973954c2fe4ad4df6ffa008c39.svg~tplv-yvqzo4lhg5-image.image',
        desc: '更高效的客户管理系统，连接广告投放与线索，提升企业营销ROI',
        link: 'https://crm.bytedance.com/feiyu/login',
        product_link: '/academy/product_detail/?id=42&one=%E6%95%88%E6%9E%9C%E5%B9%BF%E5%91%8A&oneId=1&two=%E8%BD%AC%E5%8C%96&twoId=41'
      }, {
        title: '巨量云图',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/e8cf5d7840d66c1995145dd265944e03.svg~tplv-yvqzo4lhg5-image.image',
        desc: '大数据管理平台，帮助您精准锁定目标客户，快速提升广告效果',
        link: 'https://yuntu.oceanengine.com',
        product_link: '/academy/product_detail/?id=20&one=%E6%95%88%E6%9E%9C%E5%B9%BF%E5%91%8A&oneId=1&two=%E5%AE%9A%E5%90%91&twoId=14'
      }, {
        title: '巨量创意',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/29bf0135c0ce3243f5de88b364c252af.svg~tplv-yvqzo4lhg5-image.image',
        desc: '激发创意灵感，汇集丰富视频制作模板、海量授权BGM和优秀视频案例',
        link: '//' + CC_ORIGIN,
        product_link: '/academy/product_detail/?id=78&one=%E6%95%88%E6%9E%9C%E5%B9%BF%E5%91%8A&oneId=1&two=%E5%88%9B%E6%84%8F&twoId=31'
      }, {
        title: '巨量引擎APP',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/90eac97e89ab52e80ee3b192b81c43f6.svg~tplv-yvqzo4lhg5-image.image',
        desc: '专业的移动营销管理平台，让你只需一部手机就能玩转营销。',
        link: 'https://school.oceanengine.com/course/6898952760897585160',
        product_link: 'https://school.oceanengine.com/product_detail/?id=11&one=%E6%95%88%E6%9E%9C%E5%B9%BF%E5%91%8A&oneId=1&two=%E5%B9%BF%E5%91%8A%E5%B9%B3%E5%8F%B0&twoId=111&type=course'
      }, {
        title: '巨量星图',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/1bdccc8903906c0dc81425f366c05ae0.svg~tplv-yvqzo4lhg5-image.image',
        desc: '抖音商业内容智能交易管理平台，为广告主的品牌推广匹配合适优质达人',
        link: 'https://star.toutiao.com/',
        product_link: 'https://school.oceanengine.com/learning?nav=xingtuxueyuan'
      }, {
        title: '开放平台',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/b4ec7cef30d498af1a79883a455f02f3.svg~tplv-yvqzo4lhg5-image.image',
        desc: '投放营销接口服务，全方位满足广告主自动化/智能化/个性化的营销需求',
        link: '/openapi/index.html',
        product_link: 'https://school.oceanengine.com/product_detail/?id=170&type=course'
      }, {
        title: '敬请期待',
        isHover: false,
        img: 'tos-cn-i-yvqzo4lhg5/fa893c5c9399bfc98273edd50848ad9f.svg~tplv-yvqzo4lhg5-image.image',
        desc: '更多广告产品和功能正在建设中，敬请期待',
        link: '',
        product_link: ''
      }]
      // this.$nextTick(() => {
      //   $('.product-content').each((index, item) => {
      //     $clamp(item, {clamp: 2})
      //   })
      // })
    },
    methods: {
      go2Product (product) {
        window.open(product.link)
      },
      go2ProductLesson (product) {
        window.open(product.product_link)
      }
    }
  }
</script>
